<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><a id="page_8"></a><img alt="image" src="images/f0008-01.jpg"/></p>
<p class="caption">Great-aunt Bessie’s 1897 diary, a gift from her teacher.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// image.vue?1057af99